const styles = {
  container: {
    fontFamily: 'Segoe UI, Roboto, sans-serif',
    backgroundColor: '#f9fbfc',
    color: '#2c3e50',
    padding: '0.2rem',
    minHeight: '100vh',
  },
  title: {
    fontSize: '2rem',
    color: '#2e86de',
    marginBottom: '1.5rem',
    textAlign: 'center',
  },
  input: {
    fontSize: '1rem',
    padding: '0.7rem 1rem',
    margin: '0.5rem 0.5rem 1rem 0',
    width: '100%',
    maxWidth: '400px',
    borderRadius: '6px',
    border: '1px solid #ced6e0',
    backgroundColor: '#ffffff',
    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
  },
  searchGrade: {
    fontSize: '1rem',
    padding: '0.7rem 1rem',
    margin: '0.5rem 0.5rem 1rem 0',    
    maxWidth: '400px',
    borderRadius: '6px',
    border: '1px solid #ced6e0',
    backgroundColor: '#ffffff',
    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
  },
  button: {
    backgroundColor: '#2e86de',
    border: 'none',
    padding: '0.75rem 1.5rem',
    borderRadius: '6px',
    fontSize: '1rem',
    cursor: 'pointer',
    color: '#fff',
    marginTop: '1rem',
    transition: 'background-color 0.2s ease-in-out',
  },
  question: {
    backgroundColor: '#ffffff',
    marginBottom: '1.2rem',
    padding: '1rem',
    borderRadius: '8px',
    fontSize: '1.1rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(250, 250, 250, 0.8)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '2rem',
    fontWeight: '500',
    color: '#555',
  },
  avatarContainer: {
    position: 'fixed',
    top: '1rem',
    right: '1rem',
    zIndex: 999,
  },
  avatar: {
    fontSize: '2.3rem',
    backgroundColor: '#ffffff',
    borderRadius: '50%',
    padding: '0.5rem',
    boxShadow: '0 0 6px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    textAlign: 'center',
  },
  dropdown: {
    position: 'absolute',
    top: '3.5rem',
    right: 0,
    backgroundColor: '#ffffff',
    border: '1px solid #ddd',
    borderRadius: '6px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    minWidth: '140px',
  },
  dropdownItem: {
    padding: '0.75rem 1rem',
    fontSize: '1rem',
    cursor: 'pointer',
    backgroundColor: '#fff',
    borderBottom: '1px solid #eee',
    textAlign: 'left',
  },
  option: {
    margin: '0.4rem 0',
    padding: '0.6rem 1rem',
    borderRadius: '6px',
    border: '1px solid #ced6e0',
    cursor: 'pointer',
    backgroundColor: '#f5f8fa',
    transition: 'background-color 0.2s',
  },
  optionSelected: {
    backgroundColor: '#d6eaf8',
  },
  optionCorrect: {
    backgroundColor: '#d4edda',
  },
  optionIncorrect: {
    backgroundColor: '#f8d7da',
  },
  optionMissed: {
    backgroundColor: '#fff3cd',
  },
  result: {
    marginTop: '2rem',
    fontSize: '1.2rem',
    color: '#28a745',
    textAlign: 'center',
  },
   navContainer: {
    backgroundColor: '#ffffff',
    color: '#2c3e50',
    padding: '1.5rem 1rem',
    minWidth: '220px',
    borderRight: '1px solid #ddd',
    fontFamily: 'Segoe UI, Roboto, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  navHeading: {
    fontSize: '1.2rem',
    color: '#2e86de',
    marginBottom: '1rem',
    textAlign: 'left',
  },
  navButton: (active) => ({
    backgroundColor: active ? styles.optionSelected.backgroundColor : styles.option.backgroundColor,
    border: styles.option.border,
    padding: styles.option.padding,
    borderRadius: styles.option.borderRadius,
    cursor: 'pointer',
    fontSize: '1rem',
    textAlign: 'left',
    transition: styles.option.transition,
    color: styles.container.color,
    fontWeight: active ? '600' : '400',
  }),
  

};

export default styles;
